const irrigator = () => {
   return (
      <p>
                                    
         <br /><br />
         Ирригационный насос для эндоскопии (JSFP-P1) спроектирован и изготовлен
         компанией «Chongqing Jinshan Science & Technology (Group) Co., Ltd».
         Устройство предназначено для введения воды во время эндоскопических
         процедур для отмывания стенок желудка и кишечника от крови, фекалий и
         других органических веществ с места визуализации, диагностики или лечения.
         Продукт имеет такие функции, как таймер, выбор скорости потока, аварийный
         сигнал, управление с помощью педального переключателя и т. д.
         <br /><br />                       
         <strong>Технические характеристики</strong><br /><br />

         Максимальное давление подачи: 400 кПа<br />
         Скорость потока (расход): 0-1000 мл/мин<br />
         Размеры: 324 мм * 160 мм * 155 мм<br />
         Вес: 6 кг <br />
         Максимальный уровень шума: 60 дБ (а)<br />
         <br />                                        
      </p> 
   );
}

export default irrigator;